import type { GraphViewOption } from '../../components/GraphBox/GraphViewControlBar/GraphViewControlBar.tsx';

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { assetByManufacturerViewOptions } from '../../components/GraphBox/GraphViewControlBar/GraphViewControlBarTypes/AssetByManufacturerType.tsx';
import type { ChartType } from '../../pages/Summary/Components/Charts/ChartTypes.ts';

interface SummaryGraphViews {
    assetByManufacturerView: GraphViewOption;
    selectedViewAllChart: ChartType | null;
}

const initialState: SummaryGraphViews = {
    assetByManufacturerView: assetByManufacturerViewOptions[0],
    selectedViewAllChart: null
};

export const summaryGraphViewSlice = createSlice({
    name: 'summaryGraphSelections',
    initialState,
    reducers: {
        setAssetByManufacturerView: (state, action: PayloadAction<GraphViewOption>) => {
            state.assetByManufacturerView = action.payload;
        },
        setSelectedViewAllChart: (state, action: PayloadAction<ChartType | null>) => {
            state.selectedViewAllChart = action.payload;
        },
        clearSelectedViewAllChart: (state) => {
            state.selectedViewAllChart = null;
        },
    },
});

export const {
    setAssetByManufacturerView,
    setSelectedViewAllChart,
    clearSelectedViewAllChart
} = summaryGraphViewSlice.actions;

// Updated selectors to work with the new state structure

export const selectAssetCountByManufacturerView = (state: {
    summaryGraphViewSlice: SummaryGraphViews;
}) => state.summaryGraphViewSlice.assetByManufacturerView;
export const selectAssetByManufacturerView = (state: {
    summaryGraphViewSlice: SummaryGraphViews;
}) => state.summaryGraphViewSlice.assetByManufacturerView;
export const selectSelectedViewAllChart = (state: {
    summaryGraphViewSlice: SummaryGraphViews;
}) => state.summaryGraphViewSlice.selectedViewAllChart;

export default summaryGraphViewSlice.reducer;
